{
  "actions": "Radnje",
  "actionsAvailable": "Dostupne su radnje.",
  "clearSelection": "Poništi izbor",
  "selected": "Izabrano: {count}",
  "selectedAll": "Sve je izabrano"
}
